module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/toc#preamble-D",
      "id": "preamble-R"
    }
  }, [_c('strong', [_vm._v("PREAMBLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("We the people of the United States, in order to dissolve what unity we have, establish injustice, insure domestic idiocy, provide for the common offence, promote the general despair, and secure enmity toward ourselves by our posterity, do ordain and establish this obnoxious political spectacle, the election of 2016.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-627e963e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/preamble.vue
// module id = 87
// module chunks = 0